import {useContext} from 'react';

import {DialogCloseGuardContext} from '../components/DialogCloseGuardContext';
import {closeCurrentDialog} from '../utils/closeCurrentDialog';

/** Closes the surrounding dialog through its close guard; outside a dialog, the current one. */
export function useDialogRequestClose() {
  const context = useContext(DialogCloseGuardContext);

  return context?.requestClose ?? closeCurrentDialog;
}
